
export class Component extends HTMLElement {
  public static htmlDefinition = 'component';
  constructor() {
    super();
  }
}